import styled from "styled-components";
import { Image as AntImage } from "antd";
import { DefaultIMG } from '@assets';

export const Loader = styled.div`
width: 100%;
height: calc(100vh - 150px);
display: flex;
align-items: center;
justify-content: center;
`;

export const RootContainer = styled.div`
overflow: hidden;
position: relative;
height: calc(100vh - 70px);
`;

export const Container = styled.div`
margin: 0 16px;
`;

export const ButtonWrapper = styled.div`
position: absolute;
bottom: 0;
width: calc(100% - 32px);
padding: 16px 0;

.ant-btn {
  height: 52px;
  width: 100%;
  border: none !important;
}
`;

export const Top = styled.div`
padding: 16px 0;
display: flex;
gap: 10px;
flex-direction: column;
align-items: center;
justify-content: center;
position: relative;

svg {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: DefaultIMG,
  preview: false,
})`
  width: 120px !important;
  height: 120px !important;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 16px;
`;

export const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #1E1E1E;
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  height: calc(100vh - 370px);
  margin: 0;
  overflow: auto;
`;

export const PlayerBox = styled.div`
  background: #F7F7F7;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
  border-radius: 16px;
`;

export const Number = styled.p`
min-width: 20px;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #1E1E1E;
`;

export const DataContainer = styled.div`
  flex-grow: 1;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 8px;
  border-left: 1px solid #F4F4F4;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PlayerName = styled.p`
  flex-grow: 1;
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const Amount = styled.p`
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #E39401;
`

export const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PhoneNumber = styled.p`
  flex-grow: 1;
  color:  #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
export const Text = styled.span`
font-size: 14px;
font-weight: 400;
color: #616161;
line-height: 1.5;
`;

export const BoldText = styled.span`
font-size: 14px;
font-weight: 700;
line-height: 1.5;
color: #E39401;
`;